import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { Tooltip as ReactTippy } from 'react-tippy';
/** Tooltipの表示をヘッダー要素より下位に表示するための設定 */
const underHeaderComponentPopperOptions = {
    modifiers: [
        {
            enabled: true,
            fn(data) {
                const newData = data;
                // ヘッダーコンポーネントより上に表示されないようにz-indexを調整
                newData.instance.popper.style.zIndex = 1000;
                return newData;
            },
            name: 'style',
        },
    ],
};
export const Tooltip = (props) => {
    const { animation, arrow, children, className = '', customStyle = {}, disabled, distance, duration, html, isUnderHeaderComponent = false, open, popperOptions: propPopperOptions, position, trigger, zIndex, } = props;
    // style設定
    const style = useMemo(() => (Object.assign(Object.assign({}, customStyle), { zIndex: zIndex !== null && zIndex !== void 0 ? zIndex : 9999 })), [customStyle, zIndex]);
    // popper設定
    const popperOptions = useMemo(() => (Object.assign(Object.assign({}, propPopperOptions), (isUnderHeaderComponent ? underHeaderComponentPopperOptions : {}))), [propPopperOptions, isUnderHeaderComponent]);
    if (!html) {
        // Tooltipに表示する内容がない場合
        return _jsx("div", Object.assign({ className: className }, { children: children }));
    }
    return (_jsx(ReactTippy, Object.assign({ animation: animation, arrow: arrow, className: className, disabled: disabled, distance: distance, duration: duration, html: html, open: open, popperOptions: popperOptions, position: position, style: style, trigger: trigger }, { children: children })));
};
